// Replaces the operator ID in the URL with ":operatorId" and preserves any subsequent path segments
export const replaceOperatorIdInPath = (pathname: string): string => {
  return pathname.replace(
    /\/operators\/\w+(\/\w+)?/,
    (match, p1) => `/operators/:operatorId${p1 || ""}`
  );
};
